import React from "react";
import { useForm, useFormContext } from "react-hook-form";
import InputArea from "../../../common/components/FormFields/InputArea";
import InputField from "../../../common/components/FormFields/InputField";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import RadioField from "../../../common/components/FormFields/RadioField";
import { Divider } from "@mui/material";

export default function GyncMenstrualHistory(props) {
  // const defaultValues = {
  //     menstrualHistory: "",
  //   };

  const firstRadio = [
    {
      id: "Heavy",
      label: "Heavy",
      value: "Heavy",
    },
    {
      id: "Normal",
      label: "Normal",
      value: "Normal",
    },
  ];

  const secondRadio = [
    {
      id: "Painfull",
      label: "Painful",
      value: "Painful",
    },
    {
      id: "Painless",
      label: "Painless",
      value: "Painless",
    },
  ];

  const {
    control,
    watch,
    register,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useFormContext({
    mode: "onChange",
    // defaultValues,
  });

  React.useEffect(() => {
    if (watch("isHeavy") === true) {
      setValue("isNormal", false);
    }
  }, [watch("isHeavy")]);

  React.useEffect(() => {
    if (watch("isNormal") === true) {
      setValue("isHeavy", false);
    }
  }, [watch("isNormal")]);

  React.useEffect(() => {
    if (watch("painLess") === true) {
      setValue("painFull", false);
    }
  }, [watch("painLess")]);

  React.useEffect(() => {
    if (watch("painFull") === true) {
      setValue("painLess", false);
    }
  }, [watch("painFull")]);

  return (
    <div>
      <div>
        <div className="border border-gray-300  rounded">
          <div className="grid grid-cols-4 gap-2 items-center rounded px-2 bg-[#cafafc]">
            <label className="text-sm font-semibold col-span-2">
              Menstrual History
            </label>
            <div className="font-semibold text-sm">
              <CheckBoxField
                control={control}
                name={"menstrualRegular"}
                label={"Regular"}
              />
            </div>
          </div>
          <div className="px-2 my-1 grid grid-cols-2 gap-2">
            <InputField
              control={control}
              name="menstrualDuration"
              label="Duration"
            />
            <InputField
              control={control}
              name="menstrualLength"
              label="Length"
            />
          </div>
          <div className="my-1 px-2 flex  whitespace-nowrap gap-2">
            <div className="flex justify-center w-[50%]">
              <fieldset
                onClick={(e) => {
                  setValue("isHeavy", !watch("isHeavy"));
                }}
                className={`${
                  watch("isHeavy") === true
                    ? `rounded-lg px-3 border border-gray-400 bg-[#b1bafc]  mx-3 h-7 cursor-pointer`
                    : `rounded-lg px-3 border border-gray-400 mx-3 h-7 cursor-pointer`
                }`}
              >
                Heavy
              </fieldset>
              <fieldset
                onClick={(e) => {
                  setValue("isNormal", !watch("isNormal"));
                }}
                className={`${
                  watch("isNormal") === true
                    ? `rounded-lg px-3 border border-gray-400 bg-[#b1bafc]  mx-3 h-7 cursor-pointer`
                    : `rounded-lg px-3 border border-gray-400 mx-3 h-7 cursor-pointer`
                }`}
              >
                Normal
              </fieldset>
            </div>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ marginX: 1 }}
              className="bg-[#0B83A5]"
            />
            <div className="flex justify-center w-[50%]">
              <fieldset
                onClick={(e) => {
                  setValue("painLess", !watch("painLess"));
                }}
                className={`${
                  watch("painLess") === true
                    ? `rounded-lg px-3 border border-gray-400 bg-[#b1bafc]  mx-3 h-7 cursor-pointer`
                    : `rounded-lg px-3 border border-gray-400 mx-3 h-7 cursor-pointer`
                }`}
              >
                Painless
              </fieldset>
              <fieldset
                onClick={(e) => {
                  setValue("painFull", !watch("painFull"));
                }}
                className={`${
                  watch("painFull") === true
                    ? `rounded-lg px-3 border border-gray-400 bg-[#b1bafc]  mx-3 h-7 cursor-pointer`
                    : `rounded-lg px-3 border border-gray-400 mx-3 h-7 cursor-pointer`
                }`}
              >
                Painfull
              </fieldset>
            </div>
          </div>
        </div>
        {/* <div className="flex justify-between bg-[#FBDBFE] rounded-t-md">
          <p className="text-sm font-semibold pl-2 py-1">Menstrual History</p>
        </div> */}
        <div className=" p-1 border overflow-auto  border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
          {props.pastData === null ? (
            <InputArea
              disabled={props.pastData !== null}
              name="menstrualHistory"
              placeholder="Menstrual History"
              label="Menstrual History"
              control={control}
            />
          ) : (
            <div>{props.pastData.menstrualHistory}</div>
          )}
        </div>
      </div>
    </div>
  );
}

